import React, { useState, useEffect } from "react";
import { func, string, bool, array, object } from "prop-types";
import Select from "react-select";
import CaretDownIcon from "resources/images/caret-down-black.svg";

const SearchableDropdown = ({
  options,
  onChange,
  placeholder,
  isMulti,
  isDisabled,
  id,
  name,
  initialValue,
  width,
  alwaysShowPlaceholder,
}) => {
  const [newWidth, setNewWidth] = useState(width || "250px");

  useEffect(() => {
    updateWidth(defaultValue);
  }, []);

  const getDefaultValue = () => {
    if (isMulti || alwaysShowPlaceholder) {
      return;
    }
    if (initialValue) {
      return initialValue;
    }
    if (options.length !== 0) {
      return options[0];
    }
  };

  const updateWidth = (option) => {
    // Only update the width if it a singular selection dropdown and the width is not explicitly specified.
    if (!isMulti && !width && option) {
      setNewWidth(`${option.label.length * 8}px`);
    }
  };

  const changeHandler = (option) => {
    onChange(option);
    updateWidth(option);
  };

  const defaultValue = getDefaultValue();
  const optionalProps = {};
  if (alwaysShowPlaceholder) {
    optionalProps.value = null;
  }
  return (
    <div style={{ display: "inline-block", width: newWidth }}>
      <Select
        isMulti={isMulti}
        id={id}
        name={name || id}
        isDisabled={isDisabled}
        components={{ IndicatorsContainer: CaretDownComponent }}
        options={options}
        placeholder={placeholder}
        onChange={changeHandler}
        styles={dropDownStyles}
        defaultValue={defaultValue}
        {...optionalProps}
      />
    </div>
  );
};

const dropDownStyles = {
  control: (styles) => ({
    ...styles,
  }),
  menu: (styles) => ({
    ...styles,
  }),
  multiValue: (styles) => ({
    ...styles,
    backgroundColor: "#eff5fe",
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    color: "#317ff6",
  }),
  multiValueLabel: (styles) => ({
    ...styles,
    color: "#317ff6",
  }),
};

const CaretDownComponent = () => (
  <img
    src={CaretDownIcon}
    style={{ width: "16px", height: "16px", marginRight: "6px" }}
    alt="caret-down"
  />
);

SearchableDropdown.propTypes = {
  options: array.isRequired,
  onChange: func.isRequired,
  placeholder: string,
  isMulti: bool,
  isDisabled: bool,
  id: string,
  name: string,
  initialValue: object,
  width: string,
  alwaysShowPlaceholder: bool,
};

export default SearchableDropdown;
